// extracted by css-extract-rspack-plugin
export default {"dropdown":"LYwgMF7KaRQocKWl"};